import * as d3 from 'd3';

import Constants from '../Constants';

export default class ForceLayout {
  private documents: any;
  private collisionRadius: number;

  constructor(documents, radius = null) {
    this.documents = documents;
    if (radius === null) {
      this.collisionRadius = this.computeCollisionRadius(documents);
    } else {
      this.collisionRadius = radius;
    }
  }

  computeCollisionRadius(documents): number {
    return (
      Constants.forceLayout.collisionRadiusFactor / Math.sqrt(documents.length)
    );
  }

  getDocuments() {
    return this.documents;
  }

  getCollisionRadius() {
    return this.collisionRadius;
  }

  applyCollisionsAndRepulsion() {
    const collisionRadius = this.getCollisionRadius();
    const documents = this.getDocuments();
    const simulation = d3
      .forceSimulation(documents)
      .force('collide', d3.forceCollide().radius(collisionRadius))
      .stop();

    let iterations = 0;

    while (
      iterations < Constants.forceLayout.maxIterations &&
      simulation.alpha() > Constants.forceLayout.thresholdAlpha
    ) {
      simulation.tick();
      iterations++;
    }

    return documents;
  }

  applyIdentity() {
    return this.getDocuments();
  }

  applyCollisions() {
    const collisionRadius = this.getCollisionRadius();
    const documents = this.getDocuments();

    const simulation = d3
      .forceSimulation(documents)
      .force(
        'collision',
        d3.forceCollide().radius(() => {
          return collisionRadius;
        }),
      )
      .stop();

    let iterations = 0;
    while (
      iterations < 1000 &&
      simulation.alpha() > Constants.forceLayout.thresholdAlpha
    ) {
      simulation.tick();
      iterations++;
    }

    return documents;
  }
}
